import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import { ServiceName } from "../../../../../../../../constants";
import { COLORS, fontMixin, getColorByService } from "../../../../../../../../styles";

interface GLI_ContainerProps {
	$isSelected: boolean;
	$service: ServiceName;
}

export const GLI_Container = styled(motion.div)<GLI_ContainerProps>`
	position: relative;
	width: 100%;
	min-height: 220px;

	display: grid;
	grid-template-columns: minmax(0, 1fr) 420px;
	gap: 15px 20px;

	background: #ffffff;
	border-radius: 10px;
	box-shadow: 0 4px 14px rgba(0, 0, 0, 0.16);
	padding: 70px 30px 30px;

	border: 1px solid transparent;

	@media (max-width: 1100px) {
		grid-template-columns: 1fr;
		gap: 24px;
	}

	${({ $isSelected, $service }) => css`
		${GLI_Back_Button} {
			svg {
				path {
					stroke: ${getColorByService($service)};
				}
			}
		}
	`}

	${({ $isSelected, $service }) =>
		$isSelected &&
		css`
			border-color: ${getColorByService($service)};
		`}
`;

export const GLI_Back_Button = styled(motion.button)`
	display: flex;
	width: 40px;
	height: 25px;
	position: absolute;
	top: 30px;
	left: 30px;
	padding: 0;
	margin: 0;
	background: transparent;
	border: 0;
	cursor: pointer;

	svg {
		width: 40px;
		height: 25px;
	}
`;

export const GLI_NameGroupLesson = styled(motion.div)`
	display: flex;
	align-items: center;
	min-height: 100px;
	${fontMixin({ size: 18, weight: 700 })}
	line-height: 25px;
	color: ${COLORS.Dark_Gray};
`;

export const groupLessonItemVariants = {
	hidden: {
		opacity: 0,
		y: 18,
		scale: 0.96,
		filter: "blur(5px)",
	},
	visible: {
		opacity: 1,
		y: 0,
		scale: 1,
		filter: "blur(0px)",
		transition: {
			duration: 0.34,
			ease: [0.16, 1, 0.3, 1],
		},
	},
	exit: {
		opacity: 0,
		y: -10,
		scale: 0.97,
		filter: "blur(4px)",
		transition: {
			duration: 0.18,
			ease: "easeOut",
		},
	},
};
